import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default {
  methods: {
    print() {
      const filename = 'Experiment-results.pdf';
      const title = `Experiment: ${this.experiment.title}`;
      const wells = this.experiment.wells;
      html2canvas(document.querySelector('#pdf-board'), { scale: 1 }).then((canvas) => {
        const pdf = new jsPDF('p', 'mm', 'a4'); // eslint-disable-line
        pdf.text(title, 10, 20);
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 35, 190, 110);
        pdf.addPage('a4', 'p');
        let finalY = 15;
        let higestInRow = 0;
        for (let i = 0; i < wells.length; i++) { // eslint-disable-line
          if (i === 9) break;
          const combinations = wells[i].combinations;
          const coordinates = this.wellCoordinates(wells[i].x_position, wells[i].y_position)
            .toUpperCase();
          const rowIndex = i % 3;

          switch (rowIndex) {
            case 0:
              pdf.text(coordinates, 15, finalY);
              pdf.autoTable({
                body: combinations,
                columns: [{ header: 'Name', dataKey: 'name' }, { header: 'Weight', dataKey: 'weight' }],
                margin: { right: 140 },
                startY: finalY + 5,
                styles: { cellPadding: 0.5, fontSize: 8 },
              });
              higestInRow = Math.max(higestInRow, pdf.previousAutoTable.finalY);
              break;
            case 1:
              pdf.text(coordinates, 75, finalY);
              pdf.autoTable({
                body: combinations,
                columns: [{ header: 'Name', dataKey: 'name' }, { header: 'Weight', dataKey: 'weight' }],
                margin: { left: 75, right: 75 },
                startY: finalY + 5,
                styles: { cellPadding: 0.5, fontSize: 8 },
              });
              higestInRow = Math.max(higestInRow, pdf.previousAutoTable.finalY);
              break;
            case 2:
              pdf.text(coordinates, 140, finalY);
              pdf.autoTable({
                body: combinations,
                columns: [{ header: 'Name', dataKey: 'name' }, { header: 'Weight', dataKey: 'weight' }],
                margin: { left: 140 },
                startY: finalY + 5,
                styles: { cellPadding: 0.5, fontSize: 8 },
              });
              higestInRow = Math.max(higestInRow, pdf.previousAutoTable.finalY);
              finalY = higestInRow + 10;
              higestInRow = 0;
              break;
            default:
          }
        }
        pdf.save(filename);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/print.js